import { HTTP_REQUEST } from '@/lib/Constants';
import { Endpoints } from '@/lib/Endpoints';
import { fetcher } from '@/lib/Requester';
import { PriceData, PriceDataContainer } from '@/models/Product';

const TTL_MS = 30_000;

let inflight: Promise<PriceData | null> | null = null;
let cached: { data: PriceData | null; at: number } | null = null;

/** Dedupes concurrent /product/prices calls across homepage + campaign popup. */
export function fetchProductPrices(): Promise<PriceData | null> {
  if (cached && Date.now() - cached.at < TTL_MS) {
    return Promise.resolve(cached.data);
  }

  if (inflight) return inflight;

  inflight = (async () => {
    try {
      const response = await fetcher<PriceDataContainer>({
        params: {},
        cacheKey: 'product_prices_shared',
        endpoint: Endpoints.PRICES,
        method: HTTP_REQUEST.GET,
        cacheEnabled: false,
      });
      const data = response?.items ?? null;
      cached = { data, at: Date.now() };
      return data;
    } catch {
      return null;
    } finally {
      inflight = null;
    }
  })();

  return inflight;
}
